import { Lightning } from 'components/Lightning';
import { KoobTooltip } from '@koob/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function CheckoutHotelRoomAllotmentAvailable({ scope, room }) {
  const { t } = useTranslation();

  return scope === 'dmc' ? (
    <KoobTooltip
      tip={
        room?.supplier?.toUpperCase() === 'KOEDIA'
          ? t('connectedChannelManager:tooltip')
          : t('allotments:tooltip')
      }
      hasArrow={false}
      color="purple"
    >
      <div className="bg-green-100 rounded-full h-6 w-6 flex items-center justify-center">
        <i className="fa fa-bolt text-green-500" />
      </div>{' '}
    </KoobTooltip>
  ) : (
    <Lightning popover={t('booking:room.instantAvaibility')} />
  );
}
